module.exports = __webpack_public_path__ + "Flag-334.895a87256dd598d0e695ce1a108ed324.svg";